import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classnames from 'clsx';
import { Checkbox } from 'ui-components/components/checkbox';
import { messages } from '../../../messages';
import { ProductDetailsContext } from '../../../context';
import Global from '../../../../../store/global-selectors';

import generalStyle from '../../../style.module.css';
import style from './locations.module.css';

export const ProductActiveShippingLocations = () => {
  const { productActiveLocations, setProductActiveLocations } = useContext(ProductDetailsContext);

  const sellerShipFroms = useSelector(Global.selectSellerShipFroms);

  const onChange = (isActive, e) => {
    const warehouseId = e.target.name;
    const targetShipFrom = sellerShipFroms.find((shipFrom) => shipFrom.shipFromId === warehouseId);
    const newActiveLocation = {
      warehouseId,
      warehouseName: targetShipFrom.name,
      isSelected: isActive,
    };

    setProductActiveLocations((prevActiveLocations) => {
      // find the active location and flip the isSelected/isActive bool
      const index = prevActiveLocations.findIndex((loc) => loc.warehouseId === warehouseId);
      const newLocations = [...prevActiveLocations];
      newLocations[index] = newActiveLocation;
      return newLocations;
    });
  };

  return (
    <>
      <div className={classnames(generalStyle['shipping-defaults-header-wrapper'], generalStyle.dropped)}>
        <div className={generalStyle['shipping-defaults-header-text']}>
          <FormattedMessage {...messages.productLocations} />
        </div>
      </div>
      <div className={style['product-locations']}>
        {sellerShipFroms.map((location) => (
          <Checkbox
            key={location.shipFromId}
            checked={productActiveLocations.find((activeLocation) => activeLocation.warehouseId === location.shipFromId)?.isSelected}
            className={style['product-locations-checkbox']}
            label={location.name}
            name={location.shipFromId}
            onChange={onChange}
          />
        ))}
      </div>
    </>
  );
};
